import React from 'react'
import PersonInputsuggest from '../Person/PersonInput'

export default function PersonMovieSuggest(props) {
  const { editData, sendinputdata, sendBooleanValueChangeDone, inputData } = props
  return (
    <>
      <PersonInputsuggest
        editData={editData}
        sendinputdata={sendinputdata}
        sendtruevalue={sendBooleanValueChangeDone}
        name={'Basedon'}
        inputField1={'based'}
        inputField2={'basedte'}
        inputData={inputData}
      />
      {/* <PersonInputsuggest
        editData={editData}
        sendinputdata={sendinputdata}
        sendtruevalue={sendBooleanValueChangeDone}
        name={'MusicalLabel'}
        inputField1={'Moviemusiclabel'}
        inputField2={'Moviemusiclabelte'}
        inputData={inputData}
      /> */}
    </>
  )
}
